var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"deb3c17341bf5c94ca227fb774959675b50f8ddb"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from "@sentry/nextjs";

import { BUILD_VERSION, SENTRY_DSN, SENTRY_ENV } from "./domain/env";

Sentry.init({
  dsn: SENTRY_DSN,
  environment: SENTRY_ENV,
  release: `visualization-tool@${BUILD_VERSION}`,
  tracesSampleRate: 1.0,
  ignoreErrors: [
    // The ResizeObserver error is actually not problematic
    // @see https://forum.sentry.io/t/resizeobserver-loop-limit-exceeded/8402
    "ResizeObserver loop",
  ],
});
